module.exports = __webpack_public_path__ + "static/img/qudi (2).b82148a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (2).jpg
// module id = uCYq
// module chunks = 0